import React from "react";
import {AiFillGithub,AiFillLinkedin,AiFillFacebook} from "react-icons/ai"

const SocialLink = () => {
  return (
    <div data-aos="zoom-in-up" data-aos-duration="3000" data-aos-delay="2"   className="my-10">
      <div className="card w-80 mx-auto shadow-3xl">
      <h2 className="text-2xl mb-4 block text-white">You can connect with me !</h2>
        <div className="card-body text-white">
          <div className="card-actions justify-between">
            <span className="text-5xl hover:text-pink-500"><a target="_blank"  href="https://www.linkedin.com/feed/"> <AiFillLinkedin /> </a></span>
            <span className="text-5xl hover:text-pink-500"><a target="_blank"  href="https://github.com/AlaminSarkerFRII"> <AiFillGithub /> </a></span>
            <span className="text-5xl hover:text-pink-500"><a  target="_blank" href="https://www.facebook.com/profile.php?id=100007172590604"> <AiFillFacebook /> </a></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialLink;
